
import { Download } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ImageControlsProps {
  fileFormat: 'png' | 'jpeg' | 'webp';
  onFormatChange: (value: 'png' | 'jpeg' | 'webp') => void;
  onDownload: () => void;
  hasFiles: boolean;
  isMobile?: boolean;
}

const ImageControls = ({
  fileFormat,
  onFormatChange,
  onDownload,
  hasFiles,
  isMobile = false
}: ImageControlsProps) => {
  return (
    <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'} gap-4 items-stretch relative`}>
      <Select
        value={fileFormat}
        onValueChange={onFormatChange}
      >
        <SelectTrigger className="w-full md:w-[180px] bg-white relative z-50 rounded-[16px] border-2 border-[#9B87F5] text-[#6B4EE6] font-medium hover:bg-[#F8F6FF] transition-colors">
          <SelectValue placeholder="Select format" />
        </SelectTrigger>
        <SelectContent className="bg-white z-[999] rounded-[16px] border-2 border-[#9B87F5]">
          <SelectItem value="png" className="text-[#6B4EE6] hover:bg-[#F8F6FF]">PNG Format</SelectItem>
          <SelectItem value="jpeg" className="text-[#6B4EE6] hover:bg-[#F8F6FF]">JPEG Format</SelectItem>
          <SelectItem value="webp" className="text-[#6B4EE6] hover:bg-[#F8F6FF]">WebP Format</SelectItem>
        </SelectContent>
      </Select>
      
      <button
        type="button"
        onClick={onDownload}
        disabled={!hasFiles}
        className="flex-1 bg-[#6B4EE6] text-white py-3 md:py-4 px-4 md:px-6 rounded-[16px]
                 flex items-center justify-center gap-2 md:gap-3 text-base md:text-lg font-bold
                 transform transition-all duration-300
                 hover:bg-[#5B3ED6] hover:scale-105 hover:shadow-lg
                 focus:outline-none focus:ring-4 focus:ring-[#9B87F5]
                 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:hover:bg-[#6B4EE6]
                 disabled:hover:shadow-none"
      >
        <Download className="w-5 h-5 md:w-6 md:h-6" />
        {hasFiles ? 'Download Combined Image' : 'Waiting for images...'}
      </button>
    </div>
  );
};

export default ImageControls;
